import { OrganizationFeature } from '../interfaces/organization';
import { DeepReadonly } from 'utility-types';

export const isComplianceRegionUS = (features: DeepReadonly<OrganizationFeature[]>) =>
  features.includes(OrganizationFeature.ComplianceUSA);

export const isComplianceRegionCHAS = (features: DeepReadonly<OrganizationFeature[]>) =>
  [OrganizationFeature.ComplianceUK, OrganizationFeature.ComplianceAUS].some(value => features.includes(value)) &&
  !features.includes(OrganizationFeature.ComplianceUSA);

export const isComplianceRegionGlobal = (features: DeepReadonly<OrganizationFeature[]>) => {
  return features.includes(OrganizationFeature.ComplianceGlobal);
};
